import { render, staticRenderFns } from "./aboutHwkh.vue?vue&type=template&id=133b9391&scoped=true&"
import script from "./aboutHwkh.vue?vue&type=script&lang=js&"
export * from "./aboutHwkh.vue?vue&type=script&lang=js&"
import style0 from "./aboutHwkh.vue?vue&type=style&index=0&id=133b9391&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133b9391",
  null
  
)

export default component.exports